import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, Observable, throwError } from 'rxjs';
import { SKIP_AUTH_INTERCEPTOR } from './skip-interceptor.token';
import { AuthService } from 'src/app/services/auth.service';
import { AUTH_ENDPOINTS } from 'src/app/globals/app-endpoints';

export const authInterceptor: HttpInterceptorFn = (
  request: HttpRequest<any>,
  next: HttpHandlerFn,
): Observable<HttpEvent<any>> => {
  const authService = inject(AuthService);
  
  // Check the flag on this specific request
  if (request.context.get(SKIP_AUTH_INTERCEPTOR)) {
    return next(request); // pass through untouched
  }

  const token = authService.getAccessToken();
  if (token) {
    request = request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  // return next(request);
  // NEW:
  // Handle authentication errors returned by the backend.
  return next(request).pipe(
    catchError((error: HttpErrorResponse) => {

    // Session/token is invalid or expired
      if (
        (error.status === 401) &&
        !request.url.includes(AUTH_ENDPOINTS.LOGIN) &&
        !request.url.includes(AUTH_ENDPOINTS.REFRESH_TOKEN)
      ) {
        authService.logout();
      }

      // Keep propagating the error so the individual API
      // subscription can still handle it if required.
      return throwError(() => error);
    }),
  );
};


